/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const estimate: Readonly<Record<string, string>> = {
  // The card: the tabs across the top, pinning, offering, voiding, deleting
  Estimate: "Presupuesto",
  "No estimate yet": "Aún no hay presupuesto",
  "Build the contract for this job — line items, change orders, and the cost roll-up.":
    "Arma el contrato de este trabajo: líneas, órdenes de cambio y el resumen de costos.",
  "+ Create estimate": "+ Crear presupuesto",
  "+ New estimate": "+ Nuevo presupuesto",
  "Not offered to the customer — a working estimate":
    "No se ofrece al cliente: un presupuesto interno",
  "This is the estimate the job is priced on":
    "Este es el presupuesto con el que se cotiza el trabajo",
  "Not the active estimate": "No es el presupuesto activo",
  "not offered": "no ofrecido",
  "Stop pinning this one and let the rule decide again — signed, then pinned, then cheapest":
    "Dejar de fijar este y que la regla decida de nuevo: firmado, luego fijado, luego el más barato",
  "Pin this estimate as the one the job is priced on":
    "Fijar este presupuesto como el que cotiza el trabajo",
  "Un-pin": "Quitar fijación",
  "Make active": "Activar",
  "Put this back in the packet the customer chooses from":
    "Volver a incluirlo en el paquete del que elige el cliente",
  "Keep this one out of the packet — a working estimate, not one to offer":
    "Dejar este fuera del paquete: un presupuesto interno, no para ofrecer",
  "Offer to customer": "Ofrecer al cliente",
  "Do not offer": "No ofrecer",
  "Cannot be deleted — {n} order(s) already paid":
    "No se puede eliminar: {n} orden(es) ya pagada(s)",
  "Sent to the customer — void it below to clear this estimate away":
    "Enviado al cliente: anularlo abajo libera este presupuesto para quitarlo",
  "Signed once, so it is kept — leave it out of the packet instead":
    "Se firmó una vez, así que se conserva: mejor dejarlo fuera del paquete",
  "Kill the link the customer was sent, so this estimate can be changed or deleted":
    "Anular el enlace que se envió al cliente, para poder cambiar o eliminar este presupuesto",
  "This document has been signed.": "Este documento ya está firmado.",
  "Voiding it takes away its force — the signed record is kept, but the estimate stands back down and a new document has to be sent.":
    "Anularlo le quita su validez: el registro firmado se conserva, pero el presupuesto deja de estar en pie y habrá que enviar un documento nuevo.",
  "Void it anyway?": "¿Anularlo de todos modos?",
  'Void "{title}" sent to the customer?':
    '¿Anular "{title}" enviado al cliente?',
  "the document": "el documento",
  "Their link stops working. This cannot be undone — present the estimate again to send a fresh one.":
    "Su enlace deja de funcionar. Esto no se puede deshacer: presentar el presupuesto de nuevo envía uno nuevo.",
  "Voiding…": "Anulando…",
  "Void what was sent": "Anular lo enviado",
  "{n} line(s)": "{n} línea(s)",
  "{n} work order(s)": "{n} orden(es) de trabajo",
  "{n} material order(s)": "{n} orden(es) de materiales",
  "{n} expense(s)": "{n} gasto(s)",
  "{n} change order(s)": "{n} orden(es) de cambio",
  "This also deletes its {list}.": "Esto también elimina sus {list}.",
  'Delete "{name}" (v{version})?': '¿Eliminar "{name}" (v{version})?',
  "This cannot be undone.": "Esto no se puede deshacer.",
  "Delete estimate": "Eliminar presupuesto",
  "Customer can buy more than one of these":
    "El cliente puede comprar más de uno de estos",
  // multiOptionHint, in packages/core
  "You set this, so the customer can buy any of them together, two roofs included — right for a house and a garage, wrong for two alternatives for the same roof. It stays as you left it.":
    "Fijado a mano, así que el cliente puede comprar cualquiera de ellos juntos, dos techos incluidos: bien para una casa y un garaje, mal para dos alternativas del mismo techo. Se queda como se dejó.",
  "You set this. It stays as you left it.":
    "Fijado a mano. Se queda como se dejó.",
  "Set for you: options that are different work are for sale together; two roofs are a choice. Ticking it yourself lets them buy two roofs together.":
    "Fijado automáticamente: las opciones que son trabajos distintos se venden juntas; dos techos son una elección. Marcado a mano, se pueden comprar dos techos juntos.",
  "These products are missing from the catalogue, so the deck over is incomplete:":
    "Estos productos faltan en el catálogo, así que el deck over queda incompleto:",

  // The strip at the top
  Contract: "Contrato",
  Cost: "Costo",
  "Gross Profit": "Ganancia bruta",
  Margin: "Margen",
  AGP: "AGP",
  "change the margin": "cambiar el margen",
  "set the margin": "fijar el margen",

  // The builder
  "Estimate Builder": "Armador de presupuesto",
  draft: "borrador",
  submitted: "enviado",
  approved: "aprobado",
  "Contract Preview": "Vista previa del contrato",
  "Customer Name": "Nombre del cliente",
  "Job Address": "Dirección del trabajo",
  "Package name": "Nombre del paquete",
  'Blank reads as the first line item\'s name — or "Your New Roof", "Your Repair" on a repair, when that has no name either.':
    'En blanco se lee como el nombre de la primera línea, o "Your New Roof" / "Your Repair" en una reparación, cuando esa tampoco tiene nombre.',
  Discounts: "Descuentos",
  "Total Contract Amount": "Monto total del contrato",
  "Credit card fee (3%)": "Cargo por tarjeta de crédito (3%)",
  "Billed to the customer": "Facturado al cliente",
  "Present Estimate": "Presentar presupuesto",
  Invoice: "Factura",
  Trade: "Oficio",
  Trades: "Oficios",
  "Trade (all lines)": "Oficio (todas las líneas)",
  "Sets this trade on every line item and change order.":
    "Asigna este oficio a cada línea y orden de cambio.",
  "Cost Inputs": "Datos de costo",
  "Office Discount": "Descuento de oficina",
  "Discount Note": "Nota del descuento",
  "Job Overhead %": "% de gastos generales del trabajo",
  Product: "Producto",
  Qty: "Cant.",
  "Customer Price": "Precio al cliente",
  "Work Completed": "Trabajo completado",
  "No line items yet.": "Aún no hay líneas.",
  "(no name)": "(sin nombre)",
  Edit: "Editar",
  "+ Add Line Item": "+ Agregar línea",
  Totals: "Totales",
  "Change Orders": "Órdenes de cambio",
  "LineItem Discount(-)": "Descuento por línea(-)",
  "Work Not Doing": "Trabajo que no se hace",
  "Office Discount(-)": "Descuento de oficina(-)",
  "Grand Totals": "Totales generales",
  "Material Cost": "Costo de materiales",
  "1 order": "1 orden",
  "{n} orders": "{n} órdenes",
  "Labor Cost": "Costo de mano de obra",
  "Other Expenses": "Otros gastos",
  "1 item": "1 artículo",
  "{n} items": "{n} artículos",
  Returns: "Devoluciones",
  "material sent back": "material devuelto",
  "Added After Scheduling": "Agregado después de programar",
  "Click to see what was added after the job went on the calendar":
    "Clic para ver lo que se agregó después de poner el trabajo en el calendario",
  "Total Cost": "Costo total",
  "Set the margin and reprice the job":
    "Fijar el margen y recalcular el precio del trabajo",
  "Job Overhead": "Gastos generales del trabajo",

  // Added after scheduling
  Material: "Material",
  Labor: "Mano de obra",
  Expense: "Gasto",
  "Everything that landed on this job after it went on the calendar on {date}.":
    "Todo lo que llegó a este trabajo después de ponerlo en el calendario el {date}.",
  "This job has never been scheduled.": "Este trabajo nunca se ha programado.",
  Close: "Cerrar",
  Total: "Total",
  Added: "Agregado",
  Kind: "Tipo",
  Item: "Artículo",
  Document: "Documento",
  Amount: "Monto",
  "Nothing was added after this job was scheduled.":
    "No se agregó nada después de programar este trabajo.",
  "Put the job on the calendar and additions will be tracked from that point.":
    "Al poner el trabajo en el calendario, desde ese momento se registra lo agregado.",

  // Work orders and material orders
  "Work Orders": "Órdenes de trabajo",
  "Order #": "Orden nº",
  Crew: "Cuadrilla",
  Start: "Inicio",
  End: "Fin",
  Status: "Estado",
  "No work orders.": "No hay órdenes de trabajo.",
  not_scheduled: "sin programar",
  scheduled: "programado",
  completed: "completado",
  paid: "pagado",
  "+ Add Work Order": "+ Agregar orden de trabajo",
  "From Measurements": "Desde las medidas",
  "Copy From Another Estimate": "Copiar de otro presupuesto",
  "Material Orders": "Órdenes de materiales",
  Supplier: "Proveedor",
  Delivery: "Entrega",
  Subtotal: "Subtotal",
  "Tax Rate": "Tasa de impuesto",
  Tax: "Impuesto",
  "No material orders.": "No hay órdenes de materiales.",
  not_placed: "sin pedir",
  ordered: "pedido",
  picked_up: "recogido",
  "+ Add Material Order": "+ Agregar orden de materiales",

  // Change orders
  "Every change order here has been signed":
    "Todas las órdenes de cambio aquí ya están firmadas",
  "Send again": "Enviar de nuevo",
  "Send to customer": "Enviar al cliente",
  "Withdraw change order {number}": "Retirar la orden de cambio {number}",
  Description: "Descripción",
  "Unit Price": "Precio unitario",
  Unit: "Unidad",
  "No change orders.": "No hay órdenes de cambio.",
  "Delete this row?": "¿Eliminar esta fila?",
  "Signed {date}": "Firmado {date}",
  "Open the copy the customer signed": "Abrir la copia que firmó el cliente",
  Opened: "Abierto",
  Sent: "Enviado",
  "Not sent": "Sin enviar",
  "+ Add Change Order": "+ Agregar orden de cambio",
  "Choose a common item…": "Elegir un artículo común…",
  "{name} — ${price} per {unit}": "{name} — ${price} por {unit}",
  "Other — type it in": "Otro: escribir a mano",
  Cancel: "Cancelar",

  // Returns and the credit memo
  "Material that went back. Enter what the credit is worth as a positive amount — it comes off the job cost.":
    "Material que se devolvió. Anotar el valor del crédito como monto positivo: se descuenta del costo del trabajo.",
  "Tax %": "Impuesto %",
  "Credit Note #": "Nota de crédito nº",
  Credit: "Crédito",
  "Nothing returned.": "Nada devuelto.",
  typed: "escrito a mano",
  "work it out": "calcularlo",
  "Total credit": "Crédito total",
  "+ Add Return": "+ Agregar devolución",
  "Nothing could be read from {file}.": "No se pudo leer nada de {file}.",
  "Add the lines by hand.": "Agregar las líneas a mano.",
  "Note: the lines add up to ${read} but the memo says ${expected}. Check for a line that could not be read.":
    "Nota: las líneas suman ${read} pero el memo dice ${expected}. Revisar si alguna línea no se pudo leer.",
  "Read {n} line(s) from {file}": "Se leyeron {n} línea(s) de {file}",
  "(credit {number})": "(crédito {number})",
  "Add these as returns?": "¿Agregar estas como devoluciones?",
  "{file} could not be read: {reason}": "No se pudo leer {file}: {reason}",
  "Reading…": "Leyendo…",
  "Upload Credit Memo": "Subir memo de crédito",
  "Credit Memo From CompanyCam": "Memo de crédito desde CompanyCam",

  // Other expenses
  Name: "Nombre",
  "Payment Type": "Forma de pago",
  "Tracking #": "Nº de seguimiento",
  Note: "Nota",
  "Change Order": "Orden de cambio",
  Date: "Fecha",
  Cash: "Efectivo",
  "Credit/Debit Card": "Tarjeta de crédito/débito",
  ACH: "ACH",
  "Check (retired)": "Cheque (retirado)",
  // The calculated rows' names, from packages/core
  Permit: "Permiso",
  Lift: "Elevador",
  Dumpster: "Contenedor",
  Crane: "Grúa",
  "GC Fee": "Cuota de contratista general",
  "No crew chosen yet. Budgeted as uninsured until one is — an insured sub costs a fraction of this.":
    "Aún no se eligió cuadrilla. Se presupuesta como sin seguro hasta que haya una: un subcontratista asegurado cuesta una fracción de esto.",
  "removed — {basis}": "quitado — {basis}",
  "Worked out from the estimate. Type over it to correct this job; clear it to go back.":
    "Calculado del presupuesto. Escribir encima corrige este trabajo; en blanco vuelve al cálculo.",
  "Edited. Clear the box to go back to the calculated amount.":
    "Editado. En blanco vuelve al monto calculado.",
  "Recorded as agreed with the customer. A note — the amount is still worked out from the estimate.":
    "Registrado como acordado con el cliente. Es solo una nota: el monto se sigue calculando del presupuesto.",
  "Mark as agreed with the customer rather than something the estimate missed":
    "Marcar como acordado con el cliente, no como algo que el presupuesto omitió",
  "Put this expense back on the job": "Volver a poner este gasto en el trabajo",
  Restore: "Restaurar",
  "This job does not have this expense. It stays listed, struck through, and can be restored.":
    "Este trabajo no tiene este gasto. Queda en la lista, tachado, y se puede restaurar.",
  "No expenses.": "No hay gastos.",
  "What this was": "Qué fue",
  "Renamed to “{name}”": "Renombrado a “{name}”",
  "Cleared a name": "Se borró un nombre",
  "Changed an amount": "Se cambió un monto",
  "Changed a payment type": "Se cambió una forma de pago",
  "Changed a trade": "Se cambió un oficio",
  "Invoice or receipt": "Factura o recibo",
  "Changed a tracking number": "Se cambió un número de seguimiento",
  Internal: "Interno",
  "Changed a note": "Se cambió una nota",
  "Agreed with the customer": "Acordado con el cliente",
  "Counts as something the estimate missed":
    "Cuenta como algo que el presupuesto omitió",
  "Changed a change-order flag": "Se cambió la marca de orden de cambio",
  "The note, with room to write it": "La nota, con espacio para escribirla",

  // The product picker
  "Search or type a name…": "Buscar o escribir un nombre…",
  "Search products…": "Buscar productos…",
  "No product matches “{query}”.": "Ningún producto coincide con “{query}”.",
  "Custom Repair": "Reparación personalizada",
  "Not in the catalogue — type it all in yourself":
    "No está en el catálogo: se escribe todo a mano",
  "Use what you typed — no product": "Usar lo escrito, sin producto",
  "Nothing matches all of “{query}” — close matches":
    "Nada coincide con todo “{query}”: coincidencias cercanas",
};
